import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  emmsheaders: null,
};
export const emmsAuthSlice = createSlice({
  name: "emmsheaders",
  initialState,
  reducers: {
    setEmmsHeaders: (state, action) => {
      state.emmsheaders = action.payload;
    },
    setEmmsLogout: (state, action) => {
      state.emmsheaders = null;
    },
  },
});

export const { setEmmsHeaders, setEmmsLogout } = emmsAuthSlice.actions;

export default emmsAuthSlice.reducer;
